import { render, staticRenderFns } from "./basic-form.html?vue&type=template&id=64b75fd5&scoped=true&external"
import script from "./basic-form.js?vue&type=script&lang=js&external"
export * from "./basic-form.js?vue&type=script&lang=js&external"
import style0 from "./basic-form.scss?vue&type=style&index=0&id=64b75fd5&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b75fd5",
  null
  
)

export default component.exports